<template>
  <div class='sub-page sub-page-leftmenu'>
    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <ResizeRow :sliderWidth="3" width="100%" :height="gridHeight" style="padding-bottom:1px;">
        <div class='position-grid' style="height:100%">
          <dx-data-grid ref='refPositionGrid'
            :remote-operations="false"
            :data-source='positionInfoList'
            :show-borders = 'true' :showRowLines = 'true' :showColumnLines='true'
            :hover-state-enabled = "true" :allowColumnResizing = 'true'
            column-resizing-mode = 'widget' :allow-column-reordering = "true"
            height='100%' :row-alternation-enabled="true"
            keyExpr="seqId" @selection-changed="selectionChanged"
            @editor-preparing='onEditorPreparing' @toolbarPreparing="onToolbarPreparing"
            @init-new-row='onInitNewRow' @exporting="onExcelExporting"
            @rowDblClick ='onRowDbClick'
            @row-removed='onRowRemoved' @row-inserted='onRowInserted'
            @row-updated='onRowUpdated' @row-updating='onRowUpdating'
            @editingStart="onEditingStart"
          >
            <DxSelection mode="single"/>
            <DxSearchPanel
              :visible="true"
              placeholder="검색..."
            />
            <DxStateStoring
              :enabled="false"
              type="localStorage"
              storage-key="position"
            />
            <DxExport
              :enabled="true"
            />
            <DxFilterRow
              :visible="true"
              apply-filter="auto"
            />
            <DxEditing
              :allow-deleting="isCRUD"
              :allow-updating="isCRUD"
              :allow-adding="true"
              :use-icons="true"
              mode='popup'
            >
              <DxPopup
                :show-title="true"
                :width="1000"
                :height="editPopupHeight"
                title="포지션등록"
              >
                <dx-position
                  my="center"
                  at="center"
                  of="window"
                />
              </DxPopup>
              <DxForm>
                <DxItem data-field="고객사코드"/>
                <DxItem data-field="컨설턴트"/>
                <DxItem data-field="코웍여부"/>
                <DxItem data-field="코웍수수료"/>
                <DxItem data-field="홈페이지게제"/>
                <DxItem data-field="포지션제목"/>
                <DxItem data-field="채용진행단계"/>
                <DxItem data-field="모집분야"/>
                <DxItem data-field="채용직급"/>
                <DxItem data-field="경력"/>
                <DxItem data-field="학력"/>
                <DxItem data-field="선호성별"/>
                <DxItem data-field="선호연령"/>
                <DxItem data-field="연봉수준"/>
                <DxItem data-field="근무예정지"/>
                <DxItem data-field="기숙조건"/>
                <DxItem data-field="기타처우"/>
                <DxItem data-field="수수료율"/>
                <DxItem
                  :col-span="2"
                  data-field="포지션정보"
                />
                <DxItem
                  :col-span="2"
                  data-field="채용정보"
                />
            </DxForm>
            </DxEditing>
            <DxColumnFixing :enabled="true"/>
            <DxColumn
            :allowEditing="isIdEdit"
            :visible="true"
            caption="고객사명"
            data-field="고객사명"
            :min-width="140"
            :fixed="true"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="포지션제목"
            data-field="포지션제목"
            :min-width="300"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="채용진행"
            data-field="채용진행단계"
            :min-width="120"
            alignment="center"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
              <DxLookup
                :data-source="processingLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="추천인원"
            data-field="추천인원"
            format="#,##0"
            dataType="number"
            :min-width="80"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="채용직급"
            data-field="채용직급"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="요구경력"
            data-field="경력"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="요구학력"
            data-field="학력"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="studyLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="선호성별"
            data-field="선호성별"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="manWoomanLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="선호연령"
            data-field="선호연령"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="연봉수준(만)"
            data-field="연봉수준"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="false"
            :visible="true"
            caption="컨설턴트"
            data-field="컨설턴트"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="모집분야"
            data-field="모집분야"
            :min-width="100"
            alignment="center"
            >
              <DxLookup
                :data-source="categoryLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="코웍여부"
            data-field="코웍여부"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
              <DxLookup
                :data-source="coworkLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="코웍수수료"
            data-field="코웍수수료"
            format="#,##0.0%"
            dataType="number"
            :min-width="90"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="홈페이지게제"
            data-field="홈페이지게제"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="homePageLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="근무예정지"
            data-field="근무예정지"
            alignment="center"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="기숙조건"
            data-field="기숙조건"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="liveLookup"
                display-expr="코드명"
                value-expr="코드명"
              />
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="기타처우"
            data-field="기타처우"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수수료율"
            data-field="수수료율"
            format="#,##0.0%"
            dataType="number"
            :min-width="100"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="isIdEdit"
            :visible="true"
            caption="고객사코드"
            data-field="고객사코드"
            :min-width="80"
            alignment="center"
            edit-cell-template="companyGridTemplate"
            >
              <DxRequiredRule message="항목을 입력하세요"/>
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="작성자"
            data-field="createdId"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="등록일"
            data-field="createdTime"
            alignment="center"
            format="yyyy-MM-dd"
            dataType="date"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수정자"
            data-field="updatedId"
            alignment="center"
            :min-width="100"
            >
              <DxLookup
                :data-source="employeeInfo"
                display-expr="성명"
                value-expr="사번"
              />
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="true"
            caption="수정일"
            data-field="updatedTime"
            alignment="center"
            format="yyyy-MM-dd"
            dataType="date"
            :min-width="100"
            sortOrder="desc"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="사용유무"
            data-field="사용유무"
            :min-width="100"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="삭제유무"
            data-field="삭제유무"
            :min-width="100"
            >
            </DxColumn>

            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="포지션정보(사내)"
            data-field="포지션정보"
            :min-width="100"
            edit-cell-template="htmlEditor"
            >
            </DxColumn>
            <DxColumn
            :allowEditing="true"
            :visible="isExporing"
            caption="채용정보(사외)"
            data-field="채용정보"
            :min-width="100"
            edit-cell-template="htmlEditor2"
            >
            </DxColumn>
            <DxMasterDetail
              :enabled="true"
              template="masterDetailTemplate"
            />

            <DxSummary>
              <DxTotalItem
                value-format='#,##0'
                show-in-column="고객사명"
                display-format="{0} (건)"
              />
            </DxSummary>
            <dx-paging :enabled="false" :page-size="pageSize"/>
            <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
            <dx-sorting mode="multi"/>

            <template #masterDetailTemplate="{ data }">
              <div style="margin-top: 0px;padding: 0;">
                <PositionDetailApplicantComponent :dataSource="data.data"/>
              </div>
            </template>

            <template #companyGridTemplate="{ data: cellInfo }" >
              <CompanyGridComponent
                :value="cellInfo.value"
                :on-value-changed="cellInfo.setValue"
                @change-selected="onChangednewDataCompany"
              />
            </template>
            <template #htmlEditor="{ data: cellInfo }" >
              <DxHtmlEditor
                :value="cellInfo.value"
                :on-value-changed="cellInfo.setValue"
                height="400px"
              >
                <DxToolbar>
                  <DxToobarItem name="undo"/>
                  <DxToobarItem name="redo"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="bold"/>
                  <DxToobarItem name="italic"/>
                  <DxToobarItem name="strike"/>
                  <DxToobarItem name="underline"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="alignLeft"/>
                  <DxToobarItem name="alignCenter"/>
                  <DxToobarItem name="alignRight"/>
                  <DxToobarItem name="alignJustify"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="orderedList"/>
                  <DxToobarItem name="bulletList"/>
                  <DxToobarItem name="color"/>
                  <DxToobarItem name="link"/>
                </DxToolbar>
              </DxHtmlEditor>
            </template>
            <template #htmlEditor2="{ data: cellInfo2 }" >
              <DxHtmlEditor
                :value="cellInfo2.value"
                :on-value-changed="cellInfo2.setValue"
                height="400px"
              >
                <DxToolbar>
                  <DxToobarItem name="undo"/>
                  <DxToobarItem name="redo"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="bold"/>
                  <DxToobarItem name="italic"/>
                  <DxToobarItem name="strike"/>
                  <DxToobarItem name="underline"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="alignLeft"/>
                  <DxToobarItem name="alignCenter"/>
                  <DxToobarItem name="alignRight"/>
                  <DxToobarItem name="alignJustify"/>
                  <DxToobarItem name="separator"/>
                  <DxToobarItem name="orderedList"/>
                  <DxToobarItem name="bulletList"/>
                  <DxToobarItem name="color"/>
                  <DxToobarItem name="link"/>
                </DxToolbar>
              </DxHtmlEditor>
            </template>
          </dx-data-grid>
        </div>
      </ResizeRow>
      <div class="detail-wrap">
        <div class="detail-title" style="margin-bottom: 8px;margin-top: 16px;">{{ positionDetail }}</div>
        <div class='sub-tab-wrap'>
          <DxTabPanel
              id="tabpanel"
              :selected-index.sync="selectedIndex"
              :data-source='tabs'
              :focusStateEnabled='true'
            >
            <template #title="{ data: tab }">
              <div class='sub-title-wrap-tab'>
                <ul>
                  <li class='float-left sub-title'>{{tab.title}}</li>
                </ul>
              </div>
            </template>
          </DxTabPanel>
          <div v-if="selectedIndex === 0">
            <div style="margin-top: 10px;padding: 0 20px; display:flex">
              <table class="table-bordered" style="width:50%;margin-right:0%">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr style="height: 210px;">
                    <th scope="row" style="text-align:center;">포지션정보</th>
                    <td >
                      <DxHtmlEditor
                        :value="selectedRow.포지션정보"
                        height="430px"
                        >
                      </DxHtmlEditor>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-bordered" style="width:50%;">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr style="height: 210px;">
                    <th scope="row" style="text-align:center;">채용정보</th>
                    <td >
                      <DxHtmlEditor
                        :value="selectedRow.채용정보"
                        height="430px"
                      >
                      </DxHtmlEditor>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if='selectedIndex === 1'>
            <div style="margin-top: 20px;padding: 0 20px; display:flex">
              <table class="table-bordered" style="width:50%;">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">업종</th>
                    <td >
                      {{ companyDetail.업종}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">종업원수</th>
                    <td >
                      {{ companyDetail.종업원수}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">상장여부</th>
                    <td >
                      {{ companyDetail.상장여부}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">평균수수료</th>
                    <td >
                      {{ companyDetail.평균수수료 | percent}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">자본금(억)</th>
                    <td >
                      {{ companyDetail.자본금 | comma}}
                    </td>
                  </tr>
                  <tr style="">
                    <th scope="row">연매출(억)</th>
                    <td >
                      {{ companyDetail.연간매출액 |comma}}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table-bordered" style="width:50%;margin-right:0%">
                <colgroup>
                  <col width="20%">
                  <col width="">
                </colgroup>
                <tbody>
                  <tr>
                    <th scope="row">본사주소</th>
                    <td >
                      {{ companyDetail.본사주소}}
                    </td>
                  </tr>
                  <tr>
                    <th scope="row">홈페이지</th>
                    <td >
                      {{ companyDetail.홈페이지}}
                    </td>
                  </tr>
                  <tr style="height: 120px;">
                    <th scope="row">고객사소개</th>
                    <td >
                      {{ companyDetail.고객사소개}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if='selectedIndex === 2' style="margin-top: 10px;padding:0 20px;">
          <FileUploadComponent :gridHeightFile="210" :fileListInfo="fileListInfo"
            :selectedParent="selectedRow" :fileType="채용정보첨부파일" :parentKey="selectedRow.seqId"
          />
        </div>
      </div>
      <DxPopupGen
        :visible.sync="popupPositionDetail"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-title="true"
        :width="popupWidth"
        :height="popupHeight"
        :title="positionDetail"
      >
        <div style="margin-top: 10px;padding: 0 20px; display:flex">
          <table class="table-bordered" style="width:50%;margin-right:0%">
            <colgroup>
              <col width="10%">
              <col width="">
            </colgroup>
            <tbody>
              <tr :style="{height: (popupHeight-60)+'px'}">
                <th scope="row" style="text-align:center;">포지션정보</th>
                <td >
                  <DxHtmlEditor
                    :value="selectedRow.포지션정보"
                    height="210px"
                    >
                  </DxHtmlEditor>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-bordered" style="width:50%;">
            <colgroup>
              <col width="10%">
              <col width="">
            </colgroup>
            <tbody>
              <tr :style="{height: (popupHeight-60)+'px'}">
                <th scope="row" style="text-align:center;">채용정보</th>
                <td >
                  <DxHtmlEditor
                    :value="selectedRow.채용정보"
                    height="210px"
                  >
                  </DxHtmlEditor>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </DxPopupGen>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem, DxSummary, DxForm, DxStateStoring,
  DxColumn, DxPaging, DxSorting, DxEditing, DxSearchPanel, DxLookup, DxPopup, DxPosition, DxMasterDetail, DxSelection
} from 'devextreme-vue/data-grid'
import { DxItem } from 'devextreme-vue/form'
import {
  DxRequiredRule
} from 'devextreme-vue/validator'
import { ResizeRow } from 'vue-resizer'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
// Our demo infrastructure requires us to use 'file-saver-es'.
// We recommend that you use the official 'file-saver' package in your applications.
import { exportDataGrid } from 'devextreme/excel_exporter'
import FileUploadComponent from '../../share/component/FileUploadComponent.vue'
import CompanyGridComponent from '../../share/component/devextream-template/CompanyGridComponent.vue'
import PositionDetailApplicantComponent from './PositionDetailApplicantComponent.vue'
import {
  DxHtmlEditor,
  DxToolbar,
  DxItem as DxToobarItem
} from 'devextreme-vue/html-editor'
import { DxPopup as DxPopupGen } from 'devextreme-vue/popup'

export default {
  name: 'position',
  data: function () {
    return {
      isLoading: false,
      selectedIndex: 0,
      editButtons: ['edit', 'delete'],
      positionInfoList: null,
      gridHeight: null,
      userInfo: null,
      isIdEdit: true,
      selectedRow: {},
      focusedRowKey: null,
      editPopupHeight: screen.height - 160,
      tabs: [
        {
          title: '채용 상세 정보'
        },
        {
          title: '고객사 정보'
        },
        {
          title: '첨부파일 관리'
        }
      ],
      positionDetail: '포지션-추가정보',
      processingLookup: this.$store.getters.getBaseDataByType(ConstDef.채용단계),
      categoryLookup: this.$store.getters.getBaseDataByType(ConstDef.모집분야),
      coworkLookup: ConstDef.코웍단독,
      homePageLookup: ConstDef.게재비게재,
      studyLookup: ConstDef.요구학력,
      manWoomanLookup: ConstDef.남녀,
      ageLookup: ConstDef.연령대,
      liveLookup: this.$store.getters.getBaseDataByType(ConstDef.주거조건),
      employeeInfo: this.$store.getters.getEmployee,
      isExporing: false,
      pageSize: 100,
      newDataCompany: null,
      companyDetail: {},
      popupPositionDetail: false,
      fromYear: null,
      thisYear: this.$_appLib.getToday(),
      fromDateBox: null,
      toDateBox: null,
      queryStringSeqId: null,
      // File upload
      채용정보첨부파일: ConstDef.채용정보첨부파일,
      fileListInfo: null,
      // detail popup
      popupWidth: screen.width - 100,
      popupHeight: screen.height - 110
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxExport,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxEditing,
    DxRequiredRule,
    DxSearchPanel,
    DxLookup,
    DxSummary,
    DxTotalItem,
    DxPopup,
    DxPosition,
    DxStateStoring,
    DxMasterDetail,
    DxTabPanel,
    DxScrolling,
    DxSelection,
    DxForm,
    DxItem,
    ResizeRow,
    FileUploadComponent,
    CompanyGridComponent,
    PositionDetailApplicantComponent,
    DxHtmlEditor,
    DxToolbar,
    DxToobarItem,
    DxPopupGen
  },
  created () {
    // // console.log(screen.height)
    this.gridHeight = (screen.height - 150 - 70 - 550)
    if (this.gridHeight < 300) {
      this.gridHeight = 300
    }
    this.gridHeightFile = 430

    // // console.log(this.employeeInfo)
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.thisYear = this.$_appLib.getToday()
    this.fromYear = this.$_appLib.calcYearFromDateFormat(this.thisYear, -1)
    this.queryStringSeqId = this.$route.query.seqId
    // console.log(this.queryStringSeqId)
    this.refreshPosition()
  },
  mounted () {
    this.$Q('#tabpanel .dx-tab:first-child').dblclick(e => {
      this.popupDetail()
    })
    if (this.queryStringSeqId !== undefined) {
      const headTitle = this.$store.getters.headTitleByPath(this.$_, this.$router.currentRoute.path)
      if (headTitle !== null) {
        this.$emit('titleFromChild', headTitle)
      } else {
        this.$emit('titleFromChild', this.$router.currentRoute.name)
      }
    }
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    popupDetail () {
      // console.log('popup detaul')
      this.popupPositionDetail = true
    },
    isCRUD (e) {
      return (e.row.data.컨설턴트 === this.userInfo.userId ||
        this.userInfo.permission === ConstDef.SYSTEM_ADMIN)
    },
    onEditorPreparing (e) {
      if (e.dataField === 'createdId' && e.row !== undefined) {
        if (e.row.isNewRow === true) {
          this.isIdEdit = true
        } else {
          this.isIdEdit = false
        }
      }
    },
    selectionChanged (e) {
      if (e.selectedRowsData.length === 0) return

      e.component.collapseAll(-1)
      if (e !== null) {
        // // console.log(e)
        this.selectedRow = e.selectedRowsData[0]
        this.positionDetail = `${this.selectedRow.포지션제목} - 추가정보`
        this.refreshFileList()
        this.refreshCompanyInfo()
      }
    },
    onExcelExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('채용정보')
      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), '채용정보.xlsx')
          this.isExporing = false
        })
      })
      e.cancel = true
    },
    onInitNewRow (row) {
      // // console.log(row)
      row.data.컨설턴트 = this.userInfo.userId
      row.data.수수료율 = 0.1
    },
    onRowDbClick (row) {
      this.$refs.refPositionGrid.instance.editRow(row.rowIndex)
      setTimeout(() => {
        this.$Q('.dx-datagrid-edit-popup .dx-popup-bottom .dx-toolbar-after').hide()
      }, 100)
    },
    onRowInserted (row) {
      // // console.log(row.data)
      if (row.data.포지션정보 !== undefined) {
        row.data.포지션정보 = row.data.포지션정보.value
      }
      if (row.data.채용정보 !== undefined) {
        row.data.채용정보 = row.data.채용정보.value
      }
      row.data.updatedTime = row.data.createdTime = this.$_appLib.getNow()
      row.data.updatedId = row.data.createdId = this.userInfo.userId
      row.data.고객사명 = this.newDataCompany.고객사명
      row.data.추천인원 = 0
      return this.$_sp.runInsertSqlProc('채용정보', ['seqId', '추천인원'], [row.data])
        .then(reponce => {
          this.$snotify.info('저장 되었습니다.')
          this.$refs.refPositionGrid.instance.refresh()
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowRemoved (row) {
      const param = { 'seqId': row.data.seqId }
      return this.$_sp.runDeleteSqlProc('채용정보', [param])
        .then(reponce => {
          this.$snotify.info('삭제 되었습니다.')
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    onRowUpdated (row) {
      if ((typeof row.data.포지션정보) === 'object') {
        row.data.포지션정보 = row.data.포지션정보.value
      }

      if ((typeof row.data.채용정보) === 'object') {
        row.data.채용정보 = row.data.채용정보.value
      }
      // console.log(row.data)
      return this.$_sp.runUpdateSqlProc('채용정보', ['seqId'], ['추천인원'], [row.data])
        .then(reponce => {
          this.$snotify.info('변경 되었습니다.')
          setTimeout(() => {
            this.$refs.refPositionGrid.instance.clearSelection()
            this.$refs.refPositionGrid.instance.selectRows([row.data.seqId], true)
          }, 500)
        })
    },
    onRowUpdating (row) {
    },
    onEditingStart (row) {
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>검색연도 : </b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.fromYear,
            type: 'date',
            max: this.thisYear,
            calendarOptions: {
              maxZoomLevel: 'decade',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy',
            onInitialized: (args) => {
              this.fromDateBox = args.component
            },
            onValueChanged: (args) => {
              this.fromYear = args.value
              this.thisYear = null
              this.thisYear = this.$_appLib.calcYearFromDateFormat(this.fromYear, 1)
              this.fromDateBox.option({ max: this.thisYear })
              this.toDateBox.option({ value: this.thisYear })
              this.refreshPosition()
            }
          }
        },
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>~</b></div>`
          }
        },
        {
          location: 'before',
          widget: 'dxDateBox',
          options: {
            width: 80,
            value: this.thisYear,
            min: this.fromYear,
            type: 'date',
            calendarOptions: {
              maxZoomLevel: 'decade',
              minZoomLevel: 'century'
            },
            displayFormat: 'yyyy',
            onInitialized: (args) => {
              this.toDateBox = args.component
            },
            onValueChanged: (args) => {
              // console.log(args.value)
              this.thisYear = args.value
              this.fromYear = this.$_appLib.calcYearFromDateFormat(this.thisYear, -1)
              this.toDateBox.option({ min: this.fromYear })
              this.fromDateBox.option({ value: this.fromYear })
              this.refreshPosition()
            }
          }
        },
        {
          location: 'before',
          widget: 'dxCheckBox',
          options: {
            value: this.isExporing,
            text: '모든 컬럼 보기',
            focusStateEnabled: true,
            onValueChanged: (args) => {
              this.isExporing = args.value
            }
          }
        }
      )
    },
    refreshCompanyInfo () {
      this.$_sp.runFindSqlProc('고객사정보', { 고객사코드: this.selectedRow.고객사코드 })
        .then(data => {
          this.companyDetail = this.$_sp.MakeModel(data)[0]
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshPosition () {
      this.isLoading = true
      const param = {
        fromDate: `${this.fromYear.substring(0, 4)}-01-01`,
        toDate: `${this.thisYear.substring(0, 4)}-12-31 23:59:59`
      }
      // console.log(param)
      this.$_sp.runFindProc('spFindAllPositionByYear', param)
        .then((data) => {
          this.positionInfoList = this.$_sp.MakeModel(data)
          this.isLoading = false
          if (this.queryStringSeqId !== undefined) {
            setTimeout(() => {
              this.$refs.refPositionGrid.instance.clearSelection()
              this.$refs.refPositionGrid.instance.selectRows([parseInt(this.queryStringSeqId)], true)
              this.$refs.refPositionGrid.instance.filter(['seqId', '=', this.queryStringSeqId])
            }, 0)
          }
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    },
    refreshFileList () {
      if (this.selectedRow.seqId !== undefined) {
        this.$_sp.runFindSqlProc('첨부파일정보', { 파일유형: this.채용정보첨부파일, 상위코드: this.selectedRow.seqId })
          .then(data => {
            this.fileListInfo = this.$_sp.MakeModel(data)
            // // console.log(this.fileListInfo)
          })
          .catch(error => {
            this.isLoading = false
            if (error.response.status === ConstDef.GENERRAL_ERROR) {
              this.$snotify.error(error.response.data.message)
            } else {
              this.$snotify.error(`에러코드 : ${error.response.status}`)
            }
          })
      }
    },
    // Company Component
    onChangednewDataCompany (row) {
      // // console.log(row)
      this.newDataCompany = row
    }

  }
}
</script>

<style lang="scss">
.table-bordered {
  width: 100%;
  margin-bottom: 0px;
  border:1px solid #acacac;
  border-collapse: collapse;
  th,td{
    border-bottom: 1px solid #acacac;
    border-right: 1px solid #acacac;
    padding: 6px;
  }
  th{
    background-color: rgb(239, 239, 239);;
  }
  .dx-htmleditor{
    border: none!important;
  }
  .dx-htmleditor-content{
    padding:4px!important;
  }
}

</style>
